/* jshint esversion: 6 */
/* jshint ignore:start */
import { useContext, useEffect, useState } from 'react';
import axios from 'axios';
import Slider from "react-slick";
import { useNavigate } from 'react-router-dom';
import { MyContext } from '../../Context/MyProvider';
import { useTranslation } from 'react-i18next';
import Loading from '../Loading';
import ImageLoad from '../ImageLoad';

const LabDetails = () => {

    const { t } = useTranslation();

    const { ApiBaseUrl, ImgBaseUrl } = useContext(MyContext);

    const [loading, setLoading] = useState(true);
    const [sliderImg, setSliderImg] = useState([]);
    const [category, setCategory] = useState([]);

    const navigator = useNavigate();

    const settings = {
        arrows: false,
        dots: false,
        infinite: true,
        speed: 1000,
        slidesToShow: 3,
        slidesToScroll: 1,
        initialSlide: 0,
        autoplay: true,
        autoplaySpeed: 3000,
        responsive: [
            { breakpoint: 1200, settings: { slidesToShow: 2, slidesToScroll: 1, centerMode: true } },
            { breakpoint: 1024, settings: { slidesToShow: 2, slidesToScroll: 1, centerMode: true } },
            { breakpoint: 770, settings: { slidesToShow: 1, slidesToScroll: 1, centerMode: false } },
        ],
    };

    useEffect(() => {
        window.scrollTo(0, 0);
        axios.get(`${ApiBaseUrl}/customer/lab_category_list`)
            .then((res) => {
                // console.log(res);
                const { ResponseCode, banner_list, category_list } = res.data;
                if (ResponseCode === 200) {
                    setLoading(false);
                    setSliderImg(banner_list);
                    setCategory(category_list);
                }
            })
            .catch((error) => {
                console.error(error);
            });
    }, []);


    const HandleNavigate = (item) => {
        navigator("/category-details");
        sessionStorage.setItem("Docdetails", JSON.stringify({ Categoryid: item.id, title: item.name }));
    };

    useEffect(() => {
        loading
            ? document.body.style.overflow = "hidden"
            : document.body.style.overflow = "auto";
    }, [loading]);

    return (
        <div className='w-full pb-[50px] width-container'>
            {loading ? <Loading CustomeStyle="fixed left-0 top-0 h-[100vh] w-full flex items-center justify-center bg-white" />
                : <div>
                    <div className="slider-container mt-[20px]">
                        <Slider {...settings}>
                            {
                                sliderImg.map((item, index) => {
                                    return <div key={index}>
                                        <ImageLoad src={ImgBaseUrl + item} CustomeStyle={"h-[220px] max-_430_:h-[200px] object-cover w-[100%] px-1 rounded-[20px]"} alt={"Slider Img"} />
                                    </div>
                                })
                            }
                        </Slider>
                    </div>

                    <div className="width-container">
                        <div className="ourservices mt-[20px]">
                            <h1 className='d-title'>{t("Category")}</h1>
                            <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-6 gap-3 mt-[20px]">
                                {category.map((item, index) => {
                                    return <div onClick={() => HandleNavigate(item)} key={index} className='h-full md:h-[200px] rounded-[15px] border cursor-pointer border-gray-200 hover:border-[#4038FF] hover:shadow-md hover:-translate-y-1 transition-all duration-300 p-[10px] flex flex-col justify-center'>
                                        <div className="">
                                            <ImageLoad src={ImgBaseUrl + item.image} CustomeStyle={"w-[100%] h-[100px] md:h-[120px] object-contain mx-auto rounded-[10px]"} alt={"logo"} />
                                        </div>
                                        <h1 className='font-[500] mt-[15px] text-center whitespace-nowrap overflow-hidden overflow-ellipsis'>{item.name}</h1>
                                    </div>
                                })}
                            </div>
                        </div>
                    </div>

                </div>}
        </div>
    )
}

export default LabDetails
/* jshint ignore:end */